import { cva } from 'class-variance-authority';

export const tagVariants = cva(
  'eye:inline-flex eye:h-auto eye:min-h-[28px] eye:w-auto eye:min-w-[97px] eye:items-center eye:gap-4xs' +
    ' eye:rounded-sm eye:border-1 eye:px-4xs eye:transition-colors',
  {
    variants: {
      variant: {
        default:
          'eye:h-auto eye:min-h-[24px] eye:min-w-[40px] eye:border-none eye:bg-black eye:[&]:text-white',
        success: 'eye:border-green-100 eye:bg-green-25',
        hint: 'eye:border-blue-150 eye:bg-blue-25',
        error: 'eye:border-red-100 eye:bg-red-25',
        warning: 'eye:border-olive-100 eye:bg-yellow-35',
        outline: 'eye:border-grey-100 eye:bg-transparent eye:[&]:text-black',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
